import { BaseControl } from '.';

/**
 * @typedef {object} TextControlOptions
 * @property {number} [maxLength] - Maximum length
 * @property {number} [minLength] - Minimum length
 * @property {string} [pattern] - Validation pattern
 */

/**
 * @extends {BaseControl<string, TextControlOptions>}
 */
export class TextControl extends BaseControl {

    /** @type {BaseControl<string>['render']} */
    render(value, onChange) {
        return (
            <label className="text-control">
                {this.label}
                <br />
                <input 
                    type="text" 
                    value={value} 
                    name={this.label}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={this.description}
                    maxLength={this.options?.maxLength}
                    minLength={this.options?.minLength}
                    pattern={this.options?.pattern}
                />
            </label>
        );
    }
}
